import {USER_ROLES} from '@udemy/organization';

import {createUDProxy, updateUDProxy} from './create-ud-proxy';

export const udMe = createUDProxy('me', 'meProperties');

transformUDMe();

export function transformUDMe() {
    if (UD.me && !UD.me.isLoading && UD.me.organization) {
        Object.assign(UD.me.organization, {
            isOwner: UD.me.organization.role === USER_ROLES.OWNER,
            isAdmin: UD.me.organization.role === USER_ROLES.ADMIN,
            isGroupAdmin: UD.me.organization.role === USER_ROLES.GROUP_ADMIN,
            isStudent: UD.me.organization.role === USER_ROLES.STUDENT,
            hasPermission: (permissionCode: string) => {
                if (!UD.me.organization.permissions) {
                    return false;
                }

                return udMe.organization.permissions
                    .map((permission: {permission: string}) => {
                        return permission.permission;
                    })
                    .includes(permissionCode);
            },
        });
    }
}

export function updateUDMe() {
    updateUDProxy('me', 'meProperties', udMe);
}
